import { BaseWebComponentRepository } from '../../../../../framework/BaseWebComponentRepository';
import { InProductTrialsOverlayWindowsAppDataProviderFactory } from '../factory/InProductTrialsOverlayWindowsAppDataProviderFactory';
import { InProductTrialsOverlayWindowsAppBaseDataProvider } from '../dataProvider/InProductTrialsOverlayWindowsAppBaseDataProvider';
import { InProductTrialsAdditionalUserSettings } from '../types/InProductTrialsAdditionalUserSettings';

export class InProductTrialsOverlayWindowsAppRepository extends BaseWebComponentRepository {
  public dataProviderFactory: InProductTrialsOverlayWindowsAppDataProviderFactory;
  public dataProvider: InProductTrialsOverlayWindowsAppBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new InProductTrialsOverlayWindowsAppDataProviderFactory(),
    });
  }

  public async getAdditionalUserSettingsForInProductTrials(): Promise<InProductTrialsAdditionalUserSettings> {
    return this.dataProvider.getAdditionalUserSettingsForInProductTrials();
  }
}
